import axios from "axios";
import { Base_URL } from "../url";

export const saveDailyTimeCard = async (timeCardData, userName) => {
  try {
    // Get organisationId from localStorage
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const organisationId =
      userDetails?.organisationId || localStorage.getItem("orgId");

    const apiData = {
      date: timeCardData.Date,
      projectCode: timeCardData.ProjectCode,
      hours: timeCardData.Hours,
      tasks: timeCardData.Tasks,
      remarks: timeCardData.Remarks,
      location: timeCardData.Location,
      organisationId: organisationId ? parseInt(organisationId) : null, // ADD THIS
    };

    console.log("Sending timecard with data:", apiData);

    const response = await axios.post(
      `${Base_URL}/DailyTimecard/CreateDailyTimecard?UserName=${userName}`,
      apiData,
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error.response?.data || "Error saving daily time card!";
  }
};

export const getAllProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`,
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects!";
  }
};

export const getSpecificUsersMissingTimecards = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/DailyTimecard/GetSpecificUsersMissingTimecards`,
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || "Error fetching specific users missing timecards!"
    );
  }
};
